/* eslint-disable */
import React from "react";
import { supabase } from "./supabaseClient";

const C = {
  primary:"#1a6b3c", primaryPale:"#e8f5ee", primaryDark:"#0d3d1f",
  amber:"#d97706",   amberPale:"#fffbeb",   amberMid:"#fde68a",
  rose:"#e11d48",    rosePale:"#fef2f2",
  blue:"#2563eb",    bluePale:"#eff6ff",
  text:"#111827",    muted:"#6b7280",       border:"#d1fae5",
  white:"#ffffff",   shadow:"rgba(0,0,0,0.06)",
};

const CRITERIA = [
  { id:"score_lesson_planning",       label:"Lesson Planning & Structure" },
  { id:"score_teaching_clarity",      label:"Clarity of Teaching & Explanation" },
  { id:"score_student_engagement",    label:"Student Engagement & Participation" },
  { id:"score_classroom_management",  label:"Classroom Management & Discipline" },
  { id:"score_use_of_resources",      label:"Use of Resources & Teaching Aids" },
  { id:"score_assessment_questioning",label:"Assessment & Questioning Technique" },
  { id:"score_pace_timing",           label:"Pace & Timing" },
];

const OVERALL_GRADES = [
  { id:"outstanding",          label:"Outstanding",          col:"#1a6b3c", bg:"#e8f5ee", score:4 },
  { id:"good",                 label:"Good",                 col:C.blue,    bg:C.bluePale, score:3 },
  { id:"requires_improvement", label:"Requires Improvement", col:C.amber,   bg:C.amberPale, score:2 },
  { id:"inadequate",           label:"Inadequate",           col:C.rose,    bg:C.rosePale, score:1 },
];

const SCORE_META = {
  4:{ label:"Outstanding",          col:"#1a6b3c", bg:"#e8f5ee" },
  3:{ label:"Good",                 col:C.blue,    bg:C.bluePale },
  2:{ label:"Requires Improvement", col:C.amber,   bg:C.amberPale },
  1:{ label:"Inadequate",           col:C.rose,    bg:C.rosePale },
};

const OBS_TYPE = {
  formal:        { label:"Formal Observation", icon:"📋" },
  learning_walk: { label:"Learning Walk",      icon:"🚶" },
};

const todayStr = () => new Date().toISOString().split("T")[0];
const fmt = d => d ? new Date(d+"T00:00:00").toLocaleDateString("en-GB",{day:"numeric",month:"short",year:"numeric"}) : "—";
const gradeFor = id => OVERALL_GRADES.find(g=>g.id===id);
const avgScore = (obs) => {
  const scores = CRITERIA.map(c=>obs[c.id]).filter(Boolean);
  return scores.length ? (scores.reduce((a,b)=>a+b,0)/scores.length) : null;
};

const emptyForm = (teacherList=[]) => ({
  teacher_name:"", class:"", subject:"", date:todayStr(),
  duration_mins:30, observation_type:"formal",
  ...Object.fromEntries(CRITERIA.map(c=>[c.id,null])),
  overall_grade:"", strengths:"", areas_for_development:"", follow_up_agreed:"",
});

function Toast({ toast }) {
  if (!toast) return null;
  return (
    <div style={{position:"fixed",top:20,right:20,zIndex:9999,background:toast.ok?"#f0fdf4":"#fef2f2",color:toast.ok?"#16a34a":"#dc2626",border:`1px solid ${toast.ok?"#bbf7d0":"#fecaca"}`,borderRadius:10,padding:"10px 18px",fontWeight:700,fontSize:13,boxShadow:"0 4px 18px rgba(0,0,0,.15)"}}>
      {toast.msg}
    </div>
  );
}

const btn = (bg,col="white") => ({background:bg,color:col,border:"none",borderRadius:8,padding:"9px 18px",fontWeight:700,fontSize:13,cursor:"pointer"});
const ghostBtn = {background:"none",border:`1px solid ${C.border}`,borderRadius:8,padding:"9px 16px",fontWeight:700,fontSize:13,cursor:"pointer",color:C.muted};
const inp = {padding:"9px 12px",borderRadius:8,border:`1px solid ${C.border}`,fontSize:13,boxSizing:"border-box",width:"100%"};

// ── Score picker: 4 tiles ──────────────────────────────────────────────────
function ScorePicker({ value, onChange }) {
  return (
    <div style={{display:"flex",gap:6}}>
      {[4,3,2,1].map(s=>{
        const m = SCORE_META[s];
        const active = value===s;
        return (
          <button key={s} onClick={()=>onChange(active?null:s)} type="button"
            style={{flex:1,padding:"7px 4px",borderRadius:8,border:`2px solid ${active?m.col:C.border}`,background:active?m.bg:"white",cursor:"pointer",transition:"all .15s",textAlign:"center"}}>
            <div style={{fontWeight:900,fontSize:16,color:active?m.col:C.muted,lineHeight:1}}>{s}</div>
            <div style={{fontSize:9,color:active?m.col:C.muted,fontWeight:600,lineHeight:1.3,marginTop:2}}>{m.label}</div>
          </button>
        );
      })}
    </div>
  );
}

// ── Single observation read-only card ──────────────────────────────────────
function ObsDetail({ obs }) {
  const grade = gradeFor(obs.overall_grade);
  const avg   = avgScore(obs);
  return (
    <div style={{padding:"4px 18px 18px",display:"flex",flexDirection:"column",gap:12}}>
      <div style={{display:"flex",gap:10,flexWrap:"wrap"}}>
        <div style={{background:"#f9fafb",borderRadius:9,padding:"10px 14px",flex:1,minWidth:160}}>
          <div style={{fontSize:10,color:C.muted,fontWeight:700,textTransform:"uppercase",marginBottom:4}}>Details</div>
          <div style={{fontSize:12,color:C.text,lineHeight:1.8}}>
            <div>📅 {fmt(obs.date)} · {obs.duration_mins||"?"}min</div>
            <div>🏫 {obs.class||"—"} · {obs.subject||"—"}</div>
            <div>👁 {OBS_TYPE[obs.observation_type]?.icon||""} {OBS_TYPE[obs.observation_type]?.label||obs.observation_type}</div>
            <div>✍️ Observed by {obs.observer_name||"—"}</div>
          </div>
        </div>
        {grade && (
          <div style={{background:grade.bg,borderRadius:9,padding:"10px 14px",border:`1px solid ${grade.col}33`,textAlign:"center",minWidth:140}}>
            <div style={{fontSize:10,color:grade.col,fontWeight:700,textTransform:"uppercase",marginBottom:6}}>Overall Grade</div>
            <div style={{fontWeight:900,fontSize:15,color:grade.col}}>{grade.label}</div>
            {avg && <div style={{fontSize:11,color:grade.col,marginTop:4}}>Avg criteria: {avg.toFixed(1)}/4</div>}
          </div>
        )}
      </div>

      <div>
        <div style={{fontSize:10,fontWeight:700,color:C.muted,textTransform:"uppercase",marginBottom:8}}>Criteria Scores</div>
        <div style={{display:"flex",flexDirection:"column",gap:6}}>
          {CRITERIA.map(c=>{
            const s = obs[c.id];
            const m = s ? SCORE_META[s] : null;
            return (
              <div key={c.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",background:"#f9fafb",borderRadius:7,padding:"7px 12px",gap:10}}>
                <span style={{fontSize:12,color:C.text}}>{c.label}</span>
                {m
                  ? <span style={{background:m.bg,color:m.col,border:`1px solid ${m.col}33`,borderRadius:6,padding:"2px 8px",fontSize:11,fontWeight:700,whiteSpace:"nowrap"}}>{s} — {m.label}</span>
                  : <span style={{color:C.muted,fontSize:11}}>Not rated</span>}
              </div>
            );
          })}
        </div>
      </div>

      {[["💪 Strengths","strengths"],["📈 Areas for Development","areas_for_development"],["✅ Follow-up Agreed","follow_up_agreed"]].map(([title,key])=>
        obs[key] ? (
          <div key={key} style={{background:"#f9fafb",borderRadius:9,padding:"10px 14px"}}>
            <div style={{fontSize:10,fontWeight:700,color:C.muted,textTransform:"uppercase",marginBottom:4}}>{title}</div>
            <div style={{fontSize:13,color:C.text,lineHeight:1.75,whiteSpace:"pre-wrap"}}>{obs[key]}</div>
          </div>
        ) : null
      )}
    </div>
  );
}

// ── Observation form ───────────────────────────────────────────────────────
function ObsForm({ staffList, timetable, observerName, onSave, onCancel }) {
  const [form,   setForm]   = React.useState(emptyForm());
  const [saving, setSaving] = React.useState(false);
  const [toast,  setToast]  = React.useState(null);
  const showToast = (msg,ok=true)=>{setToast({msg,ok});setTimeout(()=>setToast(null),3500);};
  const set = (k,v) => setForm(p=>({...p,[k]:v}));

  const teacherSubjects = React.useMemo(()=>{
    if (!form.teacher_name) return [];
    return [...new Set(timetable.filter(t=>t.teacher_name===form.teacher_name).map(t=>t.subject).filter(Boolean))];
  },[form.teacher_name,timetable]);

  const teacherClasses = React.useMemo(()=>{
    if (!form.teacher_name) return [];
    return [...new Set(timetable.filter(t=>t.teacher_name===form.teacher_name).map(t=>t.class).filter(Boolean))];
  },[form.teacher_name,timetable]);

  const allScored = CRITERIA.every(c=>form[c.id]!=null);
  const canSubmit = form.teacher_name && form.date && form.overall_grade;

  const save = async () => {
    if (!canSubmit) { showToast("Teacher, date and overall grade are required.",false); return; }
    setSaving(true);
    const payload = {
      teacher_name:form.teacher_name, class:form.class||null, subject:form.subject||null,
      date:form.date, duration_mins:form.duration_mins||null, observation_type:form.observation_type,
      ...Object.fromEntries(CRITERIA.map(c=>[c.id,form[c.id]])),
      overall_grade:form.overall_grade,
      strengths:form.strengths||null, areas_for_development:form.areas_for_development||null,
      follow_up_agreed:form.follow_up_agreed||null, observer_name:observerName,
    };
    const { data, error } = await supabase.from("classroom_observations").insert(payload).select().single();
    if (error) { showToast("Error: "+error.message,false); setSaving(false); return; }
    onSave(data);
  };

  const ta = {width:"100%",padding:"10px 12px",borderRadius:8,border:`1px solid ${C.border}`,fontSize:13,lineHeight:1.7,resize:"vertical",minHeight:80,boxSizing:"border-box",fontFamily:"inherit"};

  return (
    <div style={{display:"flex",flexDirection:"column",gap:14}}>
      <Toast toast={toast}/>
      <div style={{background:`linear-gradient(135deg,${C.primaryDark},${C.primary})`,borderRadius:14,padding:"18px 22px",color:"white",position:"sticky",top:0,zIndex:10}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:10}}>
          <div>
            <div style={{fontWeight:900,fontSize:16}}>📋 Log Observation</div>
            <div style={{fontSize:12,opacity:.8}}>Fill all criteria for a full formal observation, or just overall grade for a quick learning walk</div>
          </div>
          <div style={{display:"flex",gap:8}}>
            <button onClick={onCancel} style={{background:"rgba(255,255,255,.15)",color:"white",border:"1px solid rgba(255,255,255,.3)",borderRadius:8,padding:"8px 14px",fontWeight:700,fontSize:12,cursor:"pointer"}}>← Cancel</button>
            <button onClick={save} disabled={saving||!canSubmit} style={{background:canSubmit?"white":"rgba(255,255,255,.3)",color:canSubmit?C.primary:"rgba(255,255,255,.6)",border:"none",borderRadius:8,padding:"8px 18px",fontWeight:800,fontSize:12,cursor:canSubmit?"pointer":"not-allowed"}}>
              {saving?"Saving…":"✅ Save Observation"}
            </button>
          </div>
        </div>
      </div>

      {/* Basic info */}
      <div style={{background:C.white,borderRadius:12,border:`1px solid ${C.border}`,padding:"16px 18px",display:"flex",flexDirection:"column",gap:12}}>
        <div style={{fontWeight:800,fontSize:13,color:C.text}}>Basic Information</div>
        <div style={{display:"flex",gap:10,flexWrap:"wrap"}}>
          <div style={{flex:2,minWidth:180}}>
            <label style={{fontSize:11,fontWeight:700,color:C.muted,display:"block",marginBottom:4}}>TEACHER *</label>
            <select value={form.teacher_name} onChange={e=>set("teacher_name",e.target.value)} style={inp}>
              <option value="">Select teacher…</option>
              {staffList.map(s=><option key={s.id} value={s.name}>{s.name} ({s.role||"Teacher"})</option>)}
            </select>
          </div>
          <div style={{flex:1,minWidth:120}}>
            <label style={{fontSize:11,fontWeight:700,color:C.muted,display:"block",marginBottom:4}}>CLASS</label>
            <select value={form.class} onChange={e=>set("class",e.target.value)} style={inp}>
              <option value="">Select…</option>
              {teacherClasses.map(c=><option key={c} value={c}>{c}</option>)}
            </select>
          </div>
          <div style={{flex:1,minWidth:140}}>
            <label style={{fontSize:11,fontWeight:700,color:C.muted,display:"block",marginBottom:4}}>SUBJECT</label>
            <select value={form.subject} onChange={e=>set("subject",e.target.value)} style={inp}>
              <option value="">Select…</option>
              {teacherSubjects.map(s=><option key={s} value={s}>{s}</option>)}
            </select>
          </div>
        </div>
        <div style={{display:"flex",gap:10,flexWrap:"wrap"}}>
          <div style={{flex:1,minWidth:140}}>
            <label style={{fontSize:11,fontWeight:700,color:C.muted,display:"block",marginBottom:4}}>DATE *</label>
            <input type="date" value={form.date} onChange={e=>set("date",e.target.value)} style={inp}/>
          </div>
          <div style={{flex:1,minWidth:100}}>
            <label style={{fontSize:11,fontWeight:700,color:C.muted,display:"block",marginBottom:4}}>DURATION (mins)</label>
            <input type="number" min={5} max={90} value={form.duration_mins} onChange={e=>set("duration_mins",Number(e.target.value))} style={inp}/>
          </div>
          <div style={{flex:1,minWidth:180}}>
            <label style={{fontSize:11,fontWeight:700,color:C.muted,display:"block",marginBottom:4}}>TYPE</label>
            <select value={form.observation_type} onChange={e=>set("observation_type",e.target.value)} style={inp}>
              <option value="formal">📋 Formal Observation</option>
              <option value="learning_walk">🚶 Learning Walk</option>
            </select>
          </div>
        </div>
      </div>

      {/* Criteria */}
      <div style={{background:C.white,borderRadius:12,border:`1px solid ${C.border}`,padding:"16px 18px",display:"flex",flexDirection:"column",gap:12}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <div style={{fontWeight:800,fontSize:13,color:C.text}}>Criteria Ratings <span style={{fontWeight:400,fontSize:11,color:C.muted}}>(4=Outstanding, 3=Good, 2=Requires Improvement, 1=Inadequate)</span></div>
          {!allScored && <span style={{fontSize:11,color:C.muted}}>Optional — rate what you observed</span>}
        </div>
        {CRITERIA.map(c=>(
          <div key={c.id}>
            <div style={{fontSize:12,fontWeight:700,color:C.text,marginBottom:6}}>{c.label}</div>
            <ScorePicker value={form[c.id]} onChange={v=>set(c.id,v)}/>
          </div>
        ))}
      </div>

      {/* Overall grade */}
      <div style={{background:C.white,borderRadius:12,border:`1px solid ${C.border}`,padding:"16px 18px"}}>
        <div style={{fontWeight:800,fontSize:13,color:C.text,marginBottom:12}}>Overall Grade * <span style={{fontWeight:400,fontSize:11,color:C.muted}}>Your holistic judgment of the lesson</span></div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(160px,1fr))",gap:8}}>
          {OVERALL_GRADES.map(g=>{
            const active = form.overall_grade===g.id;
            return (
              <button key={g.id} type="button" onClick={()=>set("overall_grade",g.id)}
                style={{padding:"12px 10px",borderRadius:10,border:`2px solid ${active?g.col:C.border}`,background:active?g.bg:"white",cursor:"pointer",textAlign:"center",transition:"all .15s"}}>
                <div style={{fontWeight:800,fontSize:13,color:active?g.col:C.muted}}>{g.label}</div>
                <div style={{fontSize:10,color:active?g.col:"#9ca3af",marginTop:2}}>{g.score}/4</div>
              </button>
            );
          })}
        </div>
      </div>

      {/* Narrative */}
      <div style={{background:C.white,borderRadius:12,border:`1px solid ${C.border}`,padding:"16px 18px",display:"flex",flexDirection:"column",gap:12}}>
        <div style={{fontWeight:800,fontSize:13,color:C.text}}>Narrative Feedback</div>
        {[
          ["💪 Strengths","strengths","What did the teacher do well? What impressed you?"],
          ["📈 Areas for Development","areas_for_development","What specific improvements would raise the quality of teaching?"],
          ["✅ Follow-up Agreed","follow_up_agreed","What was discussed and agreed with the teacher after the observation?"],
        ].map(([label,key,ph])=>(
          <div key={key}>
            <label style={{fontSize:12,fontWeight:700,color:C.text,display:"block",marginBottom:6}}>{label}</label>
            <textarea placeholder={ph} value={form[key]} onChange={e=>set(key,e.target.value)} style={ta}/>
          </div>
        ))}
      </div>

      <div style={{display:"flex",justifyContent:"flex-end",gap:8,paddingBottom:20}}>
        <button onClick={onCancel} style={ghostBtn}>Cancel</button>
        <button onClick={save} disabled={saving||!canSubmit} style={btn(canSubmit?C.primary:"#9ca3af")}>
          {saving?"Saving…":"✅ Save Observation"}
        </button>
      </div>
    </div>
  );
}

// ── Main export ────────────────────────────────────────────────────────────
export function ClassroomObservationLog({ adminRole="admin" }) {
  const canLog = adminRole==="principal"||adminRole==="vice_principal";

  const [observations, setObservations] = React.useState([]);
  const [staffList,    setStaffList]    = React.useState([]);
  const [timetable,    setTimetable]    = React.useState([]);
  const [observerName, setObserverName] = React.useState("");
  const [loading,      setLoading]      = React.useState(true);
  const [view,         setView]         = React.useState("list"); // "list" | "form"
  const [expandedId,   setExpandedId]   = React.useState(null);
  const [filterTeacher,setFilterTeacher]= React.useState("all");
  const [filterType,   setFilterType]   = React.useState("all");
  const [filterGrade,  setFilterGrade]  = React.useState("all");
  const [toast,        setToast]        = React.useState(null);
  const [confirmDel,   setConfirmDel]   = React.useState(null);

  const showToast = (msg,ok=true)=>{setToast({msg,ok});setTimeout(()=>setToast(null),3500);};

  React.useEffect(()=>{
    (async()=>{
      const [{data:obsRows},{data:staffRows},{data:ttRows}] = await Promise.all([
        supabase.from("classroom_observations").select("*").order("date",{ascending:false}),
        supabase.from("staff").select("id,name,role").eq("status","Active").order("name"),
        supabase.from("timetable").select("teacher_name,class,subject"),
      ]);
      setObservations(obsRows||[]);
      setStaffList((staffRows||[]).filter(s=>{const r=(s.role||"").toLowerCase();return r.includes("teach")||r.includes("hifz");}));
      setTimetable(ttRows||[]);
      // Get observer name
      const {data:{user}} = await supabase.auth.getUser();
      if (user) {
        const {data} = await supabase.from("admin_accounts").select("name").eq("email",user.email).maybeSingle();
        setObserverName(data?.name||user.email);
      }
      setLoading(false);
    })();
  },[]);

  const deleteObs = async (id) => {
    const {error} = await supabase.from("classroom_observations").delete().eq("id",id);
    if (error){showToast("Error: "+error.message,false);return;}
    setObservations(p=>p.filter(o=>o.id!==id));
    setConfirmDel(null);
    showToast("Observation deleted.");
  };

  const teachers = [...new Set(observations.map(o=>o.teacher_name).filter(Boolean))].sort();

  const filtered = observations.filter(o=>
    (filterTeacher==="all"||o.teacher_name===filterTeacher) &&
    (filterType==="all"||o.observation_type===filterType) &&
    (filterGrade==="all"||o.overall_grade===filterGrade)
  );

  const totalFormal = observations.filter(o=>o.observation_type==="formal").length;
  const totalWalks  = observations.filter(o=>o.observation_type==="learning_walk").length;
  const outstanding = observations.filter(o=>o.overall_grade==="outstanding").length;
  const needsWork   = observations.filter(o=>o.overall_grade==="requires_improvement"||o.overall_grade==="inadequate").length;

  if (loading) return <div style={{color:C.muted,fontSize:13,padding:16}}>Loading…</div>;

  if (view==="form") return (
    <ObsForm staffList={staffList} timetable={timetable} observerName={observerName}
      onSave={(obs)=>{ setObservations(p=>[obs,...p]); setView("list"); showToast("Observation saved ✅"); }}
      onCancel={()=>setView("list")}/>
  );

  return (
    <div style={{display:"flex",flexDirection:"column",gap:14}}>
      <Toast toast={toast}/>

      {/* Header */}
      <div style={{background:C.white,borderRadius:14,padding:"18px 22px",border:`1px solid ${C.border}`,boxShadow:`0 2px 10px ${C.shadow}`}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",flexWrap:"wrap",gap:12,marginBottom:14}}>
          <div>
            <div style={{fontWeight:900,fontSize:17,color:C.primary,marginBottom:2}}>📋 Classroom Observation Log</div>
            <div style={{fontSize:12,color:C.muted}}>Formal observations and learning walks — feeds into Teacher Scorecard.</div>
          </div>
          {canLog && <button onClick={()=>setView("form")} style={btn(C.primary)}>+ Log Observation</button>}
        </div>
        <div style={{display:"flex",gap:12,flexWrap:"wrap"}}>
          {[["📋","Formal",totalFormal,C.blue,C.bluePale],["🚶","Learning Walks",totalWalks,"#7c3aed","#f5f3ff"],["⭐","Outstanding",outstanding,C.primary,C.primaryPale],["⚠️","Needs Attention",needsWork,C.rose,C.rosePale]].map(([icon,lbl,val,col,bg])=>(
            <div key={lbl} style={{background:bg,borderRadius:10,padding:"8px 14px",display:"flex",alignItems:"center",gap:9,border:`1px solid ${col}33`}}>
              <span style={{fontSize:16}}>{icon}</span>
              <div><div style={{fontWeight:900,fontSize:18,color:col,lineHeight:1}}>{val}</div><div style={{fontSize:10,color:C.muted,fontWeight:600,textTransform:"uppercase"}}>{lbl}</div></div>
            </div>
          ))}
        </div>
      </div>

      {/* Filters */}
      <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
        <select value={filterTeacher} onChange={e=>setFilterTeacher(e.target.value)} style={{padding:"8px 10px",borderRadius:7,border:`1px solid ${C.border}`,fontSize:12}}>
          <option value="all">All Teachers</option>
          {teachers.map(t=><option key={t} value={t}>{t}</option>)}
        </select>
        <select value={filterType} onChange={e=>setFilterType(e.target.value)} style={{padding:"8px 10px",borderRadius:7,border:`1px solid ${C.border}`,fontSize:12}}>
          <option value="all">All Types</option>
          <option value="formal">Formal Observations</option>
          <option value="learning_walk">Learning Walks</option>
        </select>
        <select value={filterGrade} onChange={e=>setFilterGrade(e.target.value)} style={{padding:"8px 10px",borderRadius:7,border:`1px solid ${C.border}`,fontSize:12}}>
          <option value="all">All Grades</option>
          {OVERALL_GRADES.map(g=><option key={g.id} value={g.id}>{g.label}</option>)}
        </select>
        {(filterTeacher!=="all"||filterType!=="all"||filterGrade!=="all")&&(
          <button onClick={()=>{setFilterTeacher("all");setFilterType("all");setFilterGrade("all");}} style={{...ghostBtn,padding:"8px 12px",fontSize:12}}>✕ Clear</button>
        )}
      </div>

      {/* List */}
      {filtered.length===0 ? (
        <div style={{background:C.white,borderRadius:12,padding:30,textAlign:"center",color:C.muted,fontSize:13,border:`1px solid ${C.border}`}}>
          No observations found.{canLog && " Click \"+ Log Observation\" to add the first one."}
        </div>
      ) : (
        <div style={{display:"flex",flexDirection:"column",gap:10}}>
          {filtered.map(obs=>{
            const grade = gradeFor(obs.overall_grade);
            const avg   = avgScore(obs);
            const isOpen = expandedId===obs.id;
            const typeInfo = OBS_TYPE[obs.observation_type]||{icon:"📋",label:obs.observation_type};
            return (
              <div key={obs.id} style={{background:C.white,borderRadius:12,border:`1px solid ${C.border}`,overflow:"hidden"}}>
                <div onClick={()=>setExpandedId(isOpen?null:obs.id)} style={{padding:"12px 18px",display:"flex",justifyContent:"space-between",alignItems:"center",cursor:"pointer",gap:10,flexWrap:"wrap"}}>
                  <div>
                    <div style={{fontWeight:800,fontSize:14,color:C.text}}>{obs.teacher_name}</div>
                    <div style={{fontSize:11,color:C.muted}}>{typeInfo.icon} {typeInfo.label} · {obs.class||"—"} · {obs.subject||"—"} · {fmt(obs.date)}</div>
                  </div>
                  <div style={{display:"flex",gap:8,alignItems:"center"}}>
                    {grade && <span style={{background:grade.bg,color:grade.col,border:`1px solid ${grade.col}33`,borderRadius:6,padding:"2px 9px",fontSize:11,fontWeight:700}}>{grade.label}</span>}
                    {avg && <span style={{fontSize:11,color:C.muted}}>{avg.toFixed(1)}/4</span>}
                    {canLog && (
                      <button onClick={e=>{e.stopPropagation();setConfirmDel(obs.id);setExpandedId(null);}}
                        style={{background:"none",border:"1px solid #fecaca",borderRadius:6,padding:"3px 9px",fontSize:11,color:C.rose,cursor:"pointer",fontWeight:700}}>🗑️</button>
                    )}
                    <span style={{color:C.muted,fontSize:12}}>{isOpen?"▲":"▼"}</span>
                  </div>
                </div>
                {confirmDel===obs.id && (
                  <div style={{margin:"0 18px 14px",background:C.rosePale,borderRadius:9,padding:"12px 14px",border:"1px solid #fecaca"}}>
                    <div style={{fontSize:13,color:C.text,marginBottom:10,fontWeight:600}}>Delete this observation record? This cannot be undone.</div>
                    <div style={{display:"flex",gap:8}}>
                      <button onClick={()=>deleteObs(obs.id)} style={{background:C.rose,color:"white",border:"none",borderRadius:7,padding:"7px 16px",fontWeight:700,fontSize:12,cursor:"pointer"}}>🗑️ Yes, Delete</button>
                      <button onClick={()=>setConfirmDel(null)} style={ghostBtn}>Cancel</button>
                    </div>
                  </div>
                )}
                {isOpen && <ObsDetail obs={obs}/>}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
